import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceTask } from '@era/device-task-management-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DeviceScheduledTasksCancelContainerComponent } from '../device-scheduled-tasks-cancel/device-scheduled-tasks-cancel.container';

@Component({
  selector: 'era-device-scheduled-tasks-ui',
  templateUrl: './device-scheduled-tasks.component.html',
  styleUrls: ['./device-scheduled-tasks.component.scss'],
  imports: [FaIconComponent, DeviceScheduledTasksCancelContainerComponent],
})
export class DeviceScheduledTasksComponent {
  @Input() scheduledTasks: DeviceTask[];
  @Output() readonly deleteEvent = new EventEmitter<DeviceTask>();

  public convertScheduledTask(task: string): string {
    const taskWithUppercase = task.charAt(0).toUpperCase() + task.slice(1);
    return taskWithUppercase.split('-').join(' ');
  }

  public deleteScheduledTask(event: DeviceTask) {
    this.deleteEvent.emit(event);
  }
}
